import { serviceRoles } from "config/access";
import { ENROLLMENTS } from "constants/routes";
import { checkAccess } from "helpers/auth";
import EnrollmentPage from "./container/EnrollmentPage";

export default function getSettingsRoute(userAuth) {
  const { account, aptitude } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
    [aptitude.name]: [aptitude.roles.admin],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: ENROLLMENTS,
    withSidebar: true,
    withAppBar: true,
    component: EnrollmentPage,
  };
}
